import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingQwenImageAiGeneratorConfig } from '@/data/landingConfig/landingQwenImageAiGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_QwenImageAiGenerator } from './schemaObject';

interface Props {}
const QwenImageAiGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_QwenImageAiGenerator} />
			<LandingTemplate
				data={landingQwenImageAiGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default QwenImageAiGenerator;
